import React, { useState, useEffect, useCallback, useMemo } from "react";
import "../book_components/DevelopToolComponents/toolComponents/PointPropertiesMenu/PropertiesMenu.css";
import { useDropzone } from "react-dropzone";

import { ReactComponent as DeleteIcon } from "../book_components/DevelopToolComponents/assets/delete.svg";

function BasicDropZone({
  prepareFile,
  fileReady,
  uploadFunc,
  uploading,
  updateFileName,
  handleDelete,
  initialFileName,
}) {
  const [isFileName, setIsFileName] = useState(false);

  const [fileInfo, setFileInfo] = useState(initialFileName ? { name: initialFileName, size: "" } : null);

  const onDrop = useCallback((file) => {
    if (file.length) {
      const data = new FormData();
      data.append("file", file[0]);
      // prepareFile(data);
      // updateFileName(String(file[0].path));
      setIsFileName(true);
      setFileInfo({
        name: file[0].path,
        size: file[0].size,
        date: String(file[0].lastModifiedDate),
      });
      prepareFile(data);
    }
  }, []);

  useEffect(() => {
    console.log("isFileName:", isFileName);
  }, [isFileName]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".mp3",
    maxFiles: 1,
  });

  const baseStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: "10px",
    borderRadius: 2,
    borderColor: "#ddd",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };

  const activeStyle = {
    borderColor: "#8fddeb",
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
    }),
    [isDragActive]
  );

  const convertSize = (fileSize) => {
    var sizes = ["Bytes", "KB", "MB"];
    var i = parseInt(Math.floor(Math.log(fileSize) / Math.log(1024)));
    return (fileSize / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
  };

  return (
    <>
      <div className="dropzone-container" {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p>Upload chapter audio here :)</p>
        <p>(.mp3 only)</p>
      </div>
      {fileInfo && (
        <div className={`file-status`}>
          <div className="file-info-container">
            <div style={{ paddingLeft: "0.5em" }}>
              <p className="name">{fileInfo && fileInfo.name}</p>

              {fileInfo && fileInfo.size < 1024 && <p className="size">{fileInfo.size} bytes</p>}
              {fileInfo && fileInfo.size >= 1024 && (
                <p className="size">
                  {convertSize(fileInfo.size)} ({Number(fileInfo.size).toLocaleString()} bytes)
                </p>
              )}
              {fileInfo && fileInfo.date && <p className="size">Last modified: {fileInfo.date}</p>}
            </div>
          </div>
          <div className="buttons-container">
            {fileInfo && isFileName && (
              <button className="upload-button" onClick={uploadFunc} disabled={uploading}>
                {uploading ? "Uploading..." : "Upload"}
              </button>
            )}
            <button
              className={`delete-button ${uploading ? "disabled" : ""}`}
              disabled={uploading}
              onClick={() => {
                prepareFile(null); // set the file-to-upload to null
                updateFileName(null);
                setFileInfo(null);
                setIsFileName(null);
                handleDelete();
              }}
            >
              <DeleteIcon stroke={uploading ? "#aeaeae" : "#f8ebea"} fill={uploading ? "#aeaeae" : "#f8ebea"} />
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default BasicDropZone;
